import { render, staticRenderFns } from "./ScreeningEdit.vue?vue&type=template&id=1c57e0d2&scoped=true&"
import script from "./ScreeningEdit.vue?vue&type=script&lang=js&"
export * from "./ScreeningEdit.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningEdit.vue?vue&type=style&index=0&id=1c57e0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57e0d2",
  null
  
)

export default component.exports